import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

import webDevImage1 from '../assets/images/services/it/DATA CENTRE SETUP AND INSTALLATION.jpg';
import webDevImage2 from '../assets/images/services/it/STRUCTURED CABLING AND NETWORKING.jpg';
import webDevImage3 from '../assets/images/services/it/EMS.jpg';
import webDevImage4 from '../assets/images/services/it/EMS1.jpg';

import softwareVideo from '../assets/videos/software/web-development.mp4';

import webDevBenefitsImage from '../assets/images/software/web-development.jpg';

const SoftwareWebDevelopmentPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title="Web Development" description="Professional web development services in DRC. Custom websites, web applications, and e-commerce solutions by Cool & Care." keywords="web development DRC, custom websites, web applications, e-commerce Kinshasa" />
      <ServiceSchema name="Web Development" description="Custom websites, web applications, and e-commerce development services." url="/software-web-development" />
      <BreadcrumbSchema items={[{ name: 'Software', url: '/software' }, { name: 'Web Development', url: '/software-web-development' }]} />
      <ServicePage
        serviceName={t('servicePage.services.softwareWebDevelopment.name')}
      serviceDescription={t('servicePage.services.softwareWebDevelopment.description')}
      videoUrl={softwareVideo}
      productImages={[
        webDevImage1,
        webDevImage2,
        webDevImage3,
        webDevImage4
      ]}
      features={t('servicePage.services.softwareWebDevelopment.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.softwareWebDevelopment.benefits', { returnObjects: true }) as string[]}
      benefitsImage={webDevBenefitsImage}
    />
    </>
  );
};

export default SoftwareWebDevelopmentPage;

